export default "__VITE_ASSET__5dfca5a7__$_?component__"